import React from 'react';
import './LoadingIndicator.scss';

// 回転するスピナーは使わない（design.md 6章）。跳ねるアイコンで待たせる。
const LoadingIndicator = ({ message = '会話を準備しています' }) => (
  <div className="loading-indicator">
    <div className="box">
      <div className="face" aria-hidden="true" />
      <p className="loading-text">{message}</p>
      <p className="loading-label">PREPARING</p>
    </div>
  </div>
);

export default LoadingIndicator;
